import React, { FC } from 'react'
import { motion } from 'framer-motion'
import { useInView } from 'framer-motion'
import { useRef } from 'react'

interface ReliabilityEDSSystemProps {
    epdSystemData: any
}

// Separate component for each feature card
const FeatureCard: FC<{ reliable: any; index: number }> = ({ reliable, index }) => {
    const ref = useRef(null)
    const isInView = useInView(ref, { once: false })

    return (
        <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 50 }}
            animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
            transition={{ duration: 0.5, delay: index * 0.2 }}
            className='bg-blackDark rounded-2xl'
        >
            <motion.div className="p-[1.5px] rounded-2xl " initial={{
                backgroundImage: 'none'
            }}
                whileHover={{
                    backgroundImage: `linear-gradient(156deg, ${reliable.bgColor} -38.83%, ${reliable.bgColor}00 100.93%)`,
                    scale: 1.05,
                    transition: { duration: 0.3 }
                }}>
                <div className="flex flex-col items-start justify-center p-4 md:p-4 md:px-8 bg-blackDark rounded-2xl relative group">
                    <div className='rounded-2xl w-full'>
                        <div className={`text-xl md:text-2xl text-start font-bold text-white group-hover:text-${reliable.color}`}>{reliable.key}.</div>
                        <div className={`text-lg md:text-xl text-start font-semibold text-white mb-3 group-hover:text-${reliable.color}`}>{reliable.title}</div>
                        <ul className='list-disc flex flex-col gap-2 md:gap-3 pl-5'>
                            <li>
                                <div className='text-white text-start text-sm md:text-md pr-4 md:pr-8 font-bold'>Patient management</div>
                                <div className='text-white text-start text-xs md:text-sm pr-4 md:pr-8'> {reliable.subtitle}</div>
                            </li>
                            <li>
                                <div className='text-white text-start text-sm md:text-md pr-4 md:pr-8 font-bold'>Patient management</div>
                                <div className='text-white text-start text-xs md:text-sm pr-4 md:pr-8'> {reliable.subtitle}</div>
                            </li>
                            <li>
                                <div className='text-white text-start text-sm md:text-md pr-4 md:pr-8 font-bold'>Patient management</div>
                                <div className='text-white text-start text-xs md:text-sm pr-4 md:pr-8'> {reliable.subtitle}</div>
                            </li>
                            <li>
                                <div className='text-white text-start text-sm md:text-md pr-4 md:pr-8 font-bold'>Patient management</div>
                                <div className='text-white text-start text-xs md:text-sm pr-4 md:pr-8'> {reliable.subtitle}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </motion.div>
        </motion.div>
    )
}

const EPDSysKeyFeatures: FC<ReliabilityEDSSystemProps> = ({ epdSystemData }) => {
    return (
        <div className='grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 p-4 md:p-20 py-8 md:py-12 px-4 md:px-36 bg-darkGreyPrimary'>
            {epdSystemData.EPDSystemFeatureList.map((reliable: any, index: number) => (
                <FeatureCard key={index} reliable={reliable} index={index} />
            ))}
        </div>
    )
}

export default EPDSysKeyFeatures
